import {
    gsap
} from "gsap";

export function splash() {
    // gsap.ticker.lagSmoothing(1000, 8)
    // gsap.ticker.fps(120)
    let timeline = gsap.timeline()
    if (location.pathname == "/") {

        let svgPath = document.querySelectorAll(".svgpath")

        //mvtxtrowランダム
        let mvtxtrow = document.querySelectorAll(".mvtxtrow")
        let rnd = Math.round(Math.random()) * 2
        for (let index = 0; index < mvtxtrow.length; index = index + 2) {
            if (rnd == index % 4) {
                mvtxtrow[index].classList.add("dn")
                mvtxtrow[index + 1].classList.add("dn")
            }
        }

        //path初期化
        svgPath.forEach(elem => {
            elem.style.strokeDashoffset = elem.getTotalLength() + "px"
            if (elem.classList.contains("bold")) {
                elem.style.strokeDasharray = elem.getTotalLength() + "px"
            } else {
                elem.style.strokeDasharray = elem.getTotalLength() + "px"
            }
        });

        if (!sessionStorage.getItem('splashed')) {

            let mvTtlSpan = document.querySelectorAll(".oneby1>.char"),
                mvBlock = document.querySelector(".mv__innerBlock"),
                mvScroll = document.querySelector(".mv__innerScroll"),
                headerNav = document.querySelector(".header__innerNav"),
                spheaderlogoline = document.querySelector(".spheaderlogoLine"),
                bg = document.querySelector(".bg"),
                mv = document.querySelector(".mv"),
                headerLogoLine = document.querySelector(".header__innerLogoLine"),
                headerMenu = document.querySelector(".header__innerMenu")

            noscroll(true)

            bg.style.opacity = "1"
            mv.style.opacity = "1"

            timeline
                .to(headerLogoLine, {
                    duration: 1.5,
                    delay: 1,
                    scaleX: 1,
                    ease: "circ.out",
                })
                .to(spheaderlogoline, {
                    duration: 1.5,
                    delay: 1,
                    ease: "circ.out",
                    scaleX: 1,
                }, "<")

                .to(headerLogoLine, {
                    duration: 0.5,
                    scaleX: 0,
                    transformOrigin: "center right",
                    ease: "circ.out",
                })
                .to(spheaderlogoline, {
                    duration: 0.5,
                    scaleX: 0,
                    transformOrigin: "center right",
                    ease: "circ.out",
                }, "<")

                .to(svgPath, {
                    duration: 1.6,
                    ease: "circ.out",
                    strokeDashoffset: 0,
                })

                .to([headerNav, mvBlock, mvScroll, headerMenu], {
                    duration: 0.8,
                    ease: "circ.out",
                    opacity: 1,
                    onStart: () => {
                        document.querySelector(".mv__innerTtl").classList.add("anime")
                    },
                    onComplete: () => {
                        document.body.classList.remove("loading")
                        noscroll(false)
                    }
                }, "-=1")

            // .to(mvTtlSpan, {
            //     ease: "circ.out",
            //     y: 0,
            //     stagger: {
            //         amount: 0.8,
            //         from: "start",
            //     },

            // }, "<")

            sessionStorage.setItem('splashed', true)

        } else {
            let mvTtlSpan = document.querySelectorAll(".oneby1>.char")
            document.body.classList.remove("loading")

            timeline
                .to(svgPath, {
                    duration: 1.6,
                    ease: "circ.out",
                    delay: 1,
                    strokeDashoffset: 0,
                    onStart: () => {},
                    onComplete: () => {
                        document.querySelector(".mv__innerTtl").classList.add("anime")
                        noscroll(false)
                    }
                })
            // .to(mvTtlSpan, {
            //     ease: "circ.out",
            //     y: 0,
            //     stagger: {
            //         amount: 0.8,
            //         from: "start",
            //     },

            // })
        }
    }



    function noscroll(boo) {
        if (boo) {
            document.addEventListener('touchmove', disableScroll, {
                passive: false
            });
            document.addEventListener('mousewheel', disableScroll, {
                passive: false
            });
        } else {
            document.removeEventListener('touchmove', disableScroll, {
                passive: false
            });
            document.removeEventListener('mousewheel', disableScroll, {
                passive: false
            });
        }
    }

    function disableScroll(event) {
        event.preventDefault();
    }
}